'use client'
import { useState, useEffect } from 'react'
import Form from 'components/Form'
import { dateToString } from 'utils/date'
import { findLicense } from 'services/licenses'

const CheckLicense = () => {
  const [formData, setFormData] = useState({})
  const [formSchema, setFormSchema] = useState([])
  const [sendTheForm, setSendTheForm] = useState(false)
  const [DOB, setDOB] = useState('')
  const [finalMsg, setFinalMsg] = useState()
  const [error, setError] = useState('')

  const handleChange = () => {
    if (formData?.birthDate && formData.birthDate.split('-')[0].length <= 4) {
      if (formData.birthDate !== DOB) {
        setDOB(dateToString(formData.birthDate).withYear)
      }
    }
  }

  const handleSubmit = async () => {
    if (sendTheForm) {
      setError()
      setFinalMsg()
      const response = await findLicense({ dob: DOB, doc: formData.document })
      if (response?.Data?.License) {
        setFinalMsg(response.Data)
      } else if (response.resultado === 'ERROR') {
        setError(response.error_desc)
      }
    }
    setSendTheForm(false)
  }

  const setupForm = async () => {
    const form = [
      {
        section: '',
        description: 'Introdueix les següents dades per a buscar la llicència:',
        className: 'mt-5',
        fields: [
          {
            id: 'birthDate',
            name: 'Data Naixement',
            element: 'input',
            type: 'date',
            required: true
          },
          {
            id: 'document',
            name: 'DNI / CatSalut',
            element: 'input',
            required: true
          }
        ]
      },
      {
        section: '',
        description: '',
        className: 'mt-10',
        fields: [
          {
            id: 'submit',
            name: '',
            element: 'Button',
            text: 'Consultar',
            link: '#',
            type: 'submit'
          }
        ]
      }
    ]
    setFormSchema(form)
  }

  useEffect(() => {
    setupForm()
  }, [])

  useEffect(() => {
    handleChange()
  }, [formData])

  useEffect(() => {
    handleSubmit()
  }, [sendTheForm])

  return (
    <>
      <div className="max-w-5xl mx-auto mb-48">
        <div className="mt-10 mx-4">
          <div className="text-styles">
            <h2>
              <strong>Consulta la Teva Llicència</strong>
            </h2>
          </div>
          {finalMsg && (
            <div className="text-blue font-alliance-light text-[14px] lg:text-[22px] mt-6 lg:mt-10 bg-sec-orange rounded-md p-5">
              <p className="">
                Aquestes són les dades personals que posseeix la Federació de la
                teva llicència:
              </p>
              <p className="mt-4">{`Nom i Cognoms: ${finalMsg.Name}`}</p>
              <p className="mt-4">
                {`Nº llicència Jugador: ${finalMsg.License}`}
              </p>
              <p className="mt-4">
                {`Renovada ${new Date().getFullYear()}: ${
                  finalMsg.validLicense
                }`}
              </p>
            </div>
          )}
          <Form
            form={formSchema}
            setSendTheForm={setSendTheForm}
            formData={formData}
            setFormData={setFormData}
          />
          <p className="text-sec-red font-alliance-light text-[14px] lg:text-[22px] mt-6 lg:mt-10 mb-20">
            {error}
          </p>
        </div>
      </div>
    </>
  )
}

export default CheckLicense
